  <div class="toggle" [id]="id" [class.active]="isActive">
      <div class="toggle-title" (click)="toggleActive($event)" [class.first]="isFirst">
        <div class="title"><h5 class="title-name">{{question}}</h5></div>
        <div class="icons"><i></i></div>
     </div>
     <div class="toggle-inner" *ngIf="isActive">
       <ng-content></ng-content>
     </div>
   </div>